import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

// ui
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';

// style, icons
import { styles } from '../damUseWater/style';

const useStyles = makeStyles(styles);

export default function RiskArea() {
  const { t } = useTranslation();
  const classes = useStyles();
  const [, setError] = useState('');
  const [dataHelpReport, setDataHelpReport] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      fetch(`${process.env.REACT_APP_API_BACKOFFICE_URL}/report/help`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Something went wrong ...');
        })
        .then((result) => {
          setDataHelpReport(result.data.description);
        })
        .catch((err) => setError(err));
    };
    fetchData();
  }, [dataHelpReport]);

  return (
    <Box className={classes.boxContent} p={1}>
      <Typography variant="h6">
        {t('รายงานการให้ความช่วยเหลือ')}
      </Typography>
      <Box dangerouslySetInnerHTML={{ __html: dataHelpReport }} />
    </Box>
  );
}
